<template>
  <v-toolbar-items class="hidden-sm-and-down">
    <template v-for="item in menus">
      <v-btn v-if="!item.items" :key="item.name" :to="!item.href ? { name: item.name } : null" :href="item.href" :target="item.target" rel="noopener" ripple="ripple" flat exact>{{
        item.title
      }}</v-btn>
      <v-menu v-if="item.items" :key="item.name" :group="item.group" offset-y origin="center center" transition="slide-y-transition">
        <v-btn slot="activator" ripple="ripple" flat>{{ item.title }}</v-btn>
        <v-list v-if="item.items" :key="item.name" :group="item.group">
          <v-list-tile v-for="(subItem, i) in orderBy(item.items, 'title')" :key="i" :to="genChildTarget(item, subItem)" :href="subItem.href">
            <v-list-tile-title>{{ subItem.title }}</v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-menu>
    </template>
  </v-toolbar-items>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex';
  import store from '../store/store';
  import Vue2Filters from 'vue2-filters';
  export default {
    name: 'AppDrawer',
    mixins: [Vue2Filters.mixin],
    computed: {
      ...mapGetters(['menus']),
      computeGroupActive() {
        return true;
      },
      computeLogo() {
        return '/logo.svg';
      },

      sideToolbarColor() {
        return this.$vuetify.options.extra.sideNav;
      },
    },
    created() {
      this.loadMenu();
    },
    methods: {
      ...mapActions(['loadMenu']),
      genChildTarget(item, subItem) {
        if (subItem.href) return;
        if (subItem.component) {
          return {
            name: subItem.component,
          };
        }
        return { name: `${item.group}/${subItem.name}` };
      },
    },
  };
</script>

<style lang="stylus">
  #appDrawer {
  }
</style>
